export enum PlatformAuthModalPanel {
  LOGIN = 'login',
  REGISTER = 'register',
  RESET_PASSWORD = 'resetPassword',
  SET_PASSWORD = 'setPassword',
  VERIFY_EMAIL = 'verifyEmail',
}
